import React, { useState, createContext, useContext, useEffect } from "react";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";


const UsersContext = createContext([]);

export const useUsersContext = () => useContext(UsersContext);

const UsersContextProvider = ({ children }) => {

  const auth = getAuth();

  const [loggedData, setLoggedData] = useState(null);


  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          // console.log("Usuario autenticado:", user);
          // getUsers();
          const name = user.displayName || "";
          const userLogged = user.email || "";
          setLoggedData({ email: userLogged, name: name });
        } else {
          // console.log("No hay usuario autenticado");
        }
      });
      return () => unsubscribe(); // Asegúrate de desuscribirte cuando el componente se desmonte
    }, [auth]);


    
  
  return (
    <UsersContext.Provider
      value={{
        loggedData
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};

export default UsersContextProvider;
